<div class="modal-header">
  <rask-header size="2">Flytta leverantörer</rask-header>
</div>
<div class="modal-body p-3 pb-4">
  <div class="move-leverantor-body">
    @if (form !== undefined) {
      <div>
        <div class="row">
          <div class="col-md-12" [formGroup]="form">
            <rask-search
              aid="inputAnsvarigVirkeskopareFrom"
              class="col-3"
              label="{{'LEVERANTOR_LABEL_ANSV_VIRKESKOPARE' | translate}}"
              bindLabel="namn"
              bindValue="id"
              typeToSearchText="{{ 'LEVERANTOR_DETAIL_TYPE_AHEAD_HELP_TEXT' | translate }}"
              loadingText="Laddar..."
              notFoundText="Ingen träff"
              [headerOptions]="ansvarigVirkeskopareFromHeaderOptions"
              [minTermLength]="3"
              [typeaheadFn]="searchForAnsvarigVirkeskopareTypeAhead"
              [selected]="ansvarigVirkeskopareFrom"
              [compareWith]="ansvarigVirkeskopareComparer"
              (selectedChanged)="changedAnsvarigVirkeskopareFrom($event)">
            </rask-search>
            <rask-tree-selector
              class="col-3"
              label="Leverantörsklassning"
              [items]="leverantorklassningOptions"
              [required]="false"
              aid="inputKlassning"
              formControlName="klassning">
            </rask-tree-selector>
            <rask-selector
              class="col-3"
              aid="inputLeverantorsstatus"
              label="Leverantörsstatus"
              [values]="leverantorsstatusOptions"
              [formatter]="formatter"
              [viewFormatter]="textFormatter"
              [required]="false"
              formControlName="leverantorsstatus">
            </rask-selector>
            <rask-button color="secondary" (click)="searchLeverantorer()" class="button-no-header"
            [disabled]="!hasSearchFilter()">Sök</rask-button>
            <rask-button color="secondary" (click)="clearAll()" class="button-no-header">Rensa</rask-button>
          </div>
        </div>
      </div>
    }

    <div class="px-2">
      <rask-header>Sökresultat</rask-header>
      @if (leverantorer?.length > 0) {
        <div class="move-table-wrapper">
          <table class="svea-table moveTable ms-2 w-100">
            <thead>
              <tr class="rask-header-row rask-row">
                <th class="name-column-header">Namn</th>
                <th class="name-column-header medium-cell-width">Org/Personnr</th>
                <th class="name-column-header">Adress</th>
                <th class="name-column-header medium-cell-width">Leverantörsnr</th>
                <th class="name-column-header medium-cell-width">Klassning</th>
                <th class="active-column-header">
                  <rask-checkbox (change)="checkAll($event)" [(ngModel)]="isAllChecked"></rask-checkbox>
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container>
                @for (leverantor of leverantorer; track leverantor) {
                  <tr>
                    <ng-container>
                      <td>
                        <div>
                          {{ leverantor.namn }}
                        </div>
                      </td>
                      <td>
                        <div>
                          {{ leverantor.orgnr }}
                        </div>
                      </td>
                      <td>
                        <div>
                          {{ leverantor.fullAdress }}
                        </div>
                      </td>
                      <td>
                        <div>
                          {{ leverantor.leverantorid }}
                        </div>
                      </td>
                      <td>
                        <div>
                          {{ leverantor.klassning }}
                        </div>
                      </td>
                      <td class="svea-input fkm-input-col">
                        <rask-checkbox (change)="selectedChanged($event)"
                          [(ngModel)]="leverantor.selected">
                        </rask-checkbox>
                      </td>
                    </ng-container>
                  </tr>
                }
              </ng-container>
            </tbody>
          </table>
        </div>
      }
      @if (leverantorer.length === 0) {
        <div class="ps-3">
          Inga leverantörer
        </div>
      }
    </div>
    @if ((feedbackItems | async).length > 0) {
      <rask-message-panel
        [numberOfItemsToDisplay]="1"
        [maxNumOfRows]="1"
        [labels]="[{'severity':1, 'labelText': 'Fel vid uppdatering av Lime'}]"
        [items]="feedbackItems">
      </rask-message-panel>
    }
    <div [formGroup]="form" class="d-flex justify-content-start align-items-end">
      <rask-search
        style="width: 350px"
        aid="inputAnvandareTo"
        label="Flytta markerade leverantörer till virkesköpare"
        bindLabel="namn"
        [disabled]="leverantorer?.length === 0"
        bindValue="id"
        typeToSearchText="Skriv namn.."
        loadingText="Laddar..."
        notFoundText="Ingen träff"
        formControlName="ansvarigVirkeskopareTo"
        [minTermLength]="3"
        [typeaheadFn]="searchForAnsvarigVirkeskopareTypeAhead">
      </rask-search>

      <rask-button color="primary"
        (click)="moveSelectedLeverantorer()"
      [disabled]="!hasMoveData()">Flytta {{ getSelectedCount() }} leverantörer</rask-button>
      <rask-button aid="buttonClose" class="ms-auto" color="secondary" (click)="close()">Stäng</rask-button>

    </div>
  </div>
</div>